<template>
  <div>
    <base-header class="pb-1">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Plano</h6>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <card>
        <h3 slot="header" class="mb-0">Plano {{ plan.typeSub }}</h3>
        <div class="form-row">
          <div class="col-md-12">
            <base-input label="Nome" name="nome" placeholder="Nome" required v-model="plan.name" maxlength="80">
            </base-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-4">
            <label class="form-control-label"> Taxa de Adesão </label>
            <vue-numeric name="taxaadesao" placeholder="Taxa de Adesão" class="form-control" v-model="plan.accessionFee"
              separator="." v-bind:precision="2" v-bind:minus="false" />
          </div>
          <div class="col-md-4">
            <label class="form-control-label"> Valor Titular </label>
            <vue-numeric name="precotitular" placeholder="Valor Titular" class="form-control" v-model="plan.priceHolder"
              separator="." v-bind:precision="2" v-bind:minus="false" />
          </div>
          <div class="col-md-4">
            <label class="form-control-label"> Valor Dependente </label>
            <vue-numeric name="precodependente" placeholder="Valor Dependente" class="form-control"
              v-model="plan.priceDependent" separator="." v-bind:precision="2" v-bind:minus="false" />
          </div>
        </div>
        <div class="form-row mt-3">
          <div class="col-md-4">
            <base-input label="Ativo" required name="ativo">
              <el-select v-model="plan.isActive" placeholder="Ativo?">
                <el-option v-for="option in opcoes" :key="option.label" :label="option.label" :value="option.value">
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-md-2">
            <base-input label="Renovação automática" required name="automaticRenovation">
              <el-select v-model="plan.automaticRenovation" placeholder="Renovação automática?">
                <el-option v-for="option in opcoes" :key="option.label" :label="option.label" :value="option.value">
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-md-2">
            <base-input label="Dias para Bloqueio" name="bloqueio" id="bloqueio" required
              placeholder="Dias para Bloqueio" v-model="plan.daysToBlock" :mask="['##']"></base-input>
          </div>
          <div class="col-md-2">
            <base-input label="Retentar pagamento" required name="retry">
              <el-select v-model="plan.retry" placeholder="Retentar" @change="habilita()">
                <el-option v-for="option in opcoes" :key="option.label" :label="option.label" :value="option.value">
                </el-option>
              </el-select>
            </base-input>
          </div>

          <div class="col-md-2">
            <base-input :disabled="!plan.retry" label="Qtde tentativas" name="numero" id="numero" required
              placeholder="Qtde tentativas" v-model="plan.attempts" :mask="['##']"></base-input>
          </div>
        </div>

        <div class="form-row mt-3">
          <div class="col-md-4">
            <base-input label="Disponível no Site" required name="avaliableOnline">
              <el-select v-model="plan.avaliableOnline" placeholder="Disponível no Site?">
                <el-option v-for="option in opcoes" :key="option.label" :label="option.label" :value="option.value">
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-md-2">
            <base-input label="Possui Fidelidade" required name="hasfidelity">
              <el-select v-model="plan.hasfidelity" placeholder="Possui Fidelidade?">
                <el-option v-for="option in opcoes" :key="option.label" :label="option.label" :value="option.value">
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-md-2">
            <base-input label="Permite Dependentes" required name="hasdependent">
              <el-select v-model="plan.hasdependent" placeholder="Permite Dependentes?">
                <el-option v-for="option in opcoes" :key="option.label" :label="option.label" :value="option.value">
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-md-2">
            <base-input label="Qnt limitada de vida" required name="hasLimitDependent">
              <el-select v-model="plan.hasLimitDependent" @change="habilitaQtdeVida()"
                placeholder="Possui quantidade limitade de vida?">
                <el-option v-for="option in opcoes" :key="option.label" :label="option.label" :value="option.value">
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-md-2">
            <label class="form-control-label"> Quantidade de vidas </label>
            <vue-numeric maxlength="6" :disabled="!plan.hasLimitDependent" required name="limitDependent" placeholder=""
              class="form-control" v-model="plan.limitDependent" separator="." v-bind:minus="false" />
          </div>
          <div class="col-md-2">
            <label class="form-control-label">Tamanho da fidelidade</label>
            <vue-numeric maxlength="6" :disabled="!plan.hasfidelity" name="fidelitySize" placeholder=""
              class="form-control" v-model="plan.fidelitySize" separator="." v-bind:minus="false" />
          </div>
          <div class="col-md-2">
            <label class="form-control-label">Tamanho da competência
              <el-tooltip class="item"
                content="É o periodo que cada fatura será gerada. Por exemplo, se estiver 1 mês, quer dizer que a cada 1 mês, terá uma nova fatura."
                placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip></label>
            <div class="input-group mb-3">
              <select v-if="payments.includes('AUTOMATIC_PIX')" class="form-control" v-model="plan.competence">
                <option v-if="plan.competenceType === 'MONTH'" value=1>1</option>
                <option v-if="plan.competenceType === 'MONTH'" value=3>3</option>
                <option v-if="plan.competenceType === 'MONTH'" value=6>6</option>
                <option v-if="plan.competenceType === 'YEAR'" value=1>1</option>
              </select>
              <vue-numeric v-else name="competence" class="form-control" v-model="plan.competence" :precision="0"
                :minus="false" />
              <div class="input-group-append">
                <select class="form-control" v-model="plan.competenceType">
                  <option value="MONTH">Mês</option>
                  <option value="YEAR">Ano</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <base-input label="Restrito novos clientes" required name="hasfidelity">
              <el-select v-model="plan.newCustomersOnly" placeholder="Restrito novos clientes">
                <el-option v-for="option in opcoes" :key="option.label" :label="option.label" :value="option.value">
                </el-option>
              </el-select>
            </base-input>
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col-md-2">
            <label class="form-control-label"> Parcelamento mínimo </label>
            <vue-numeric name="minInstallments" class="form-control" v-model="plan.minInstallments" :min="1"
              :empty-value="1" required />
          </div>

          <div class="col-md-2">
            <label class="form-control-label"> Parcelamento máximo </label>
            <vue-numeric name="maxInstallments" class="form-control" v-model="plan.maxInstallments"
              :min="plan.minInstallments" :empty-value="12" required />
          </div>
        </div>

        <div class="col-md-12">
          <h4>Formas de pagamento disponíveis</h4>
          <div class="form-check" v-for="type in paymentTypes" :key="type.value">
            <input class="form-check-input" type="checkbox" :value="type.value" id="paymenttype" v-model="payments" />
            <label class="form-check-label" for="paymenttype">
              {{ type.label }}
            </label>
          </div>
        </div>
        <hr />

        <fieldset>
          <legend>Campos de personalização da página de Checkout</legend>
          <div class="form-row">
            <div class="col-md-12">
              <base-input label="Nome site" name="nomesite" placeholder="Nome site" v-model="plan.siteName">
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12">
              <base-input label="Descrição" name="descricao" placeholder="Descrição" v-model="plan.description">
              </base-input>
            </div>
          </div>
          <div class="form-row mt-2">
            <div class="col-md-4">
              <label class="form-control-label">Taxa de Adesão de</label>
              <vue-numeric name="taxaadesaode" placeholder="Taxa de Adesão de" class="form-control"
                v-model="plan.priceAccessionFeeFrom" separator="." v-bind:precision="2" v-bind:minus="false" />
            </div>
            <div class="col-md-4">
              <label class="form-control-label">Valor Titular de</label>
              <vue-numeric name="precotitularde" placeholder="Valor Titular de" class="form-control"
                v-model="plan.priceHolderFrom" separator="." v-bind:precision="2" v-bind:minus="false" />
            </div>
            <div class="col-md-4">
              <label class="form-control-label">Valor Dependente de</label>
              <vue-numeric name="precodependentede" placeholder="Valor Dependente de" class="form-control"
                v-model="plan.priceDependentFrom" separator="." v-bind:precision="2" v-bind:minus="false" />
            </div>
          </div>
          <div class="form-row mt-4">
            <div class="col-md-4">
              <label class="form-control-label">Ordem no site</label>
              <vue-numeric name="siteorder" placeholder="Ordem no site" class="form-control" v-model="plan.siteOrder"
                v-bind:precision="0" v-bind:minus="false" />
            </div>
            <div class="col-md-6">
              <label class="form-control-label"></label>
              <div class="form-check mb-2 mt-3">
                <input class="form-check-input" type="checkbox" id="preferred" v-model="plan.preferred">
                <label class="form-check-label" for="preferred">
                  Plano mais escolhido
                </label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12">
              <label class="form-control-label">Denefícios</label>
              <quill-editor v-model="plan.benefits" />
            </div>
          </div>
        </fieldset>
      </card>

      <div class="col-md-12 text-center mb-3">
        <base-button type="primary" @click="save">Salvar</base-button>
        <base-button type="secondary" @click="cancel">{{ id ? "Voltar" : "Cancelar" }}</base-button>
      </div>

      <card v-if="id">
        <h3 slot="header" class="mb-0">Unidades</h3>
        <div class="form-row align-items-end">
          <div class="col-md-12">
            <base-input name="unidade">
              <el-select v-model="selectedCompany" filterable placeholder="Selecione uma unidade" class="w-100">
                <el-option v-for="company in companies" :key="company.id" :label="company.name" :value="company.id">
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-md-12 text-right mb-3">
            <base-button type="primary" @click="linkPlanToCompany">Vincular</base-button>
          </div>
        </div>
        <div class="mt-4">
          <h4>Unidades Vinculadas</h4>
          <table class="table">
            <thead>
              <tr>
                <th>Nome</th>
                <th class="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="company in linkedCompanies" :key="company.id">
                <td>{{ company.name }}</td>
                <td class="text-right">
                  <a href="#!" @click.prevent="unlinkPlanFromCompany(company.id)"
                    class="table-action table-action-delete" title="Desvincular Plano da Unidade">
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </tr>
              <tr v-if="linkedCompanies.length === 0">
                <td colspan="2" class="text-center">Nenhuma unidade vinculada</td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>

      <card v-if="id">
        <h3 slot="header" class="mb-0">Tiers</h3>
        <div class="form-row align-items-end">
          <div class="col-md-4">
            <base-input name="tier">
              <el-select v-model="selectedTier" filterable placeholder="Selecione um tier" class="w-100">
                <el-option v-for="tier in availableTiers" :key="tier.id" :label="tier.name" :value="tier.id">
                  <span :style="{ color: tier.color }">{{ tier.name }}</span>
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-md-4">
            <base-input label="Quantidade mínima de vidas" name="minLives" placeholder="Quantidade mínima de vidas"
              v-model="selectedMinLives" :mask="['####']"></base-input>
          </div>
          <div class="col-md-4 text-right mb-3">
            <base-button type="primary" @click="linkTierToPlan">Adicionar Tier</base-button>
          </div>
        </div>
        <div class="mt-4">
          <h4>Tiers Vinculados</h4>
          <table class="table">
            <thead>
              <tr>
                <th>Tier</th>
                <th>Quantidade mínima de vidas</th>
                <th class="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tierRule in linkedTiers" :key="`${tierRule.tierId}-${tierRule.minLives}`">
                <td>
                  <span :style="{ color: getTierColor(tierRule.tierId) }">
                    {{ getTierName(tierRule.tierId) }}
                  </span>
                </td>
                <td>{{ tierRule.minLives }}</td>
                <td class="text-right">
                  <a href="#!" @click.prevent="unlinkTierFromPlan(tierRule.tierId, tierRule.minLives)"
                    class="table-action table-action-delete" title="Remover Tier do Plano">
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </tr>
              <tr v-if="linkedTiers.length === 0">
                <td colspan="3" class="text-center">Nenhum tier vinculado</td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
      <div style="height: 58px;" />
    </div>
    <!--- fecha conteudo -->
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import { Table, TableColumn, Tooltip } from "element-ui";
import axios from "axios";
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  props: {
    id: {
      type: String,
      default: '0',
    },
    typeSub: {
      type: String,
      default: "PF",
    },
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [quillEditor.name]: quillEditor
  },
  mounted() {
    this.loadPlan();
    this.loadCompanies();
    this.loadTiers();
  },
  data() {
    return {
      opcoes: [
        { label: "Sim", value: true },
        { label: "Não", value: false },
      ],
      plan: {
        name: null,
        attempts: null,
        priceHolder: 0,
        priceDependent: 0,
        accessionFee: 0,
        daysToBlock: 30,
        isActive: true,
        avaliableOnline: false,
        hasfidelity: false,
        automaticRenovation: false,
        retry: true,
        hasdependent: true,
        limitDependent: 0,
        hasLimitDependent: false,
        typeSub: null,
        priceAccessionFeeFrom: null,
        priceDependentFrom: null,
        priceHolderFrom: null,
        siteName: "",
        siteOrder: 0,
        competence: 1,
        competenceType: "MONTH",
        benefits: "",
        preferred: false,
        description: "",
        fidelitySize: null,
        minInstallments: 1,
        maxInstallments: 12,
        newCustomersOnly: false
      },
      payments: [],
      paymentTypes: [
        { label: "Cartão de Crédito", value: "CREDIT_CARD" },
        { label: "Cartão de Débito", value: "DEBIT_CARD" },
        { label: "Boleto Bancário", value: "TICKET" },
        { label: "Carnê", value: "TICKETS" },
        { label: "Débito em conta", value: "DEBIT_ACCOUNT" },
        { label: "Pix automático", value: "AUTOMATIC_PIX" },
        // {label: 'Cartão de Crédito (Máquina)', value: 'CREDIT_CARD_LOCAL'},
        // {label: 'Cartão de Débito (Máquina)', value: 'DEBIT_CARD_LOCAL'},
        // {label: 'Dinheiro', value: 'MONEY'}
      ],
      allCompanies: [],
      companies: [],
      selectedCompany: null,
      linkedCompanies: [],
      allTiers: [],
      availableTiers: [],
      selectedTier: null,
      selectedMinLives: null,
      linkedTiers: []
    };
  },
  methods: {
    habilita() {
      if (!this.plan.retry) {
        this.plan.attempts = null;
      }
    },
    loadPlan() {
      if (this.id != 0) {
        //load plan data
        this.$clubApi
          .get("/plan/" + this.id)
          .then((response) => {
            this.plan = response.data.object;
            this.loadLinkedCompanies();
            this.loadLinkedTiers();
          })
          .catch(this.error)
          .finally(this.done);

        this.loadPlanPayment();
      } else {
        this.plan.typeSub = this.typeSub;
      }
    },
    loadPlanPayment() {
      //load plans payments type
      this.$clubApi
        .get("/plan/" + this.id + "/list/payments")
        .then((response) => this.payments = response.data.object)
        .catch(this.error)
        .finally(this.done);
    },
    loadCompanies() {
      this.$clubApi.get('/company?includeVirtual=true')
        .then(response => this.allCompanies = this.companies = response.data.object)
        .catch(this.error)
        .finally(this.done);
    },
    loadLinkedCompanies() {
      this.$clubApi.get(`/company/plan/${this.plan.id}?includeVirtual=true`)
        .then(response => {
          this.linkedCompanies = response.data.object;
          if (this.linkedCompanies.some(company => company.id === -1)) {
            this.companies = [];
          } else {
            this.companies = this.allCompanies.filter(company =>
              !this.linkedCompanies.some(linkedCompany => linkedCompany.id === company.id)
            );
          }
        })
        .catch(this.error)
        .finally(this.done);
    },
    save() {
      if (
        this.plan.retry &&
        this.plan.attempts != "" &&
        this.plan.attempts == 0
      ) {
        this.warning("Quantidade de tentativas tem que ser maior que zero.");
        return;
      }

      if (this.plan.daysToBlock == "" || this.plan.daysToBlock < 0) {
        this.warningy("Dias para bloqueio deve ser maior que zero.");
        return;
      }

      if (this.plan.hasLimitDependent) {
        if (this.plan.limitDependent === 0) {
          this.warning("Quantidade de vidas tem que ser maior que zero.");
          return;
        }
      }

      if (this.id == null) {
        return false;
      }
      this.$clubApi
        .post("/plan/save", this.plan)
        .then((response) => {
          this.plan = response.data.object;

          //salvando tipos de pagamento
          this.$clubApi
            .post(`/plan/save/paymenttype/${this.plan.id}`, this.payments)
            .then(() => this.success("Plano salvo com sucesso"))
            .catch(this.error)
            .finally(this.done);
        })
        .catch(this.error);

      if (process.env.NODE_ENV === 'production') {
        axios.post(
          "https://bdaf81ikua.execute-api.us-east-1.amazonaws.com/log",
          JSON.stringify({
            user: localStorage.getItem("name"),
            request: this.plan
          }),
          {
            headers: {
              "Content-Type": "application/json"
            }
          });
      }
    },
    cancel() {
      location.href = '/configuracoes/plano/' + (this.id ? this.plan.typeSub : this.typeSub);
    },
    linkPlanToCompany() {
      if (!this.selectedCompany) {
        this.warning('Por favor, selecione uma filial.');
        return;
      }

      this.$clubApi.post(`/company/${this.selectedCompany}/plan/${this.plan.id}`)
        .then(() => {
          this.success('Plano vinculado à filial com sucesso!');
          this.loadLinkedCompanies();
          this.selectedCompany = null;
          this.selectedCompany = null;
        })
        .catch(this.error)
        .finally(this.done);
    },
    unlinkPlanFromCompany(companyId) {
      this.$clubApi.delete(`/company/${companyId}/plan/${this.plan.id}`)
        .then(() => {
          this.success('Plano desvinculado da filial com sucesso!');
          this.loadLinkedCompanies();
        })
        .catch(this.error)
        .finally(this.done);
    },
    habilitaQtdeVida() {
      if (!this.plan.hasLimitDependent) {
        this.plan.limitDependent = 0;
      }
    },
    loadTiers() {
      this.$clubApi.get('/tier')
        .then(response => {
          this.allTiers = response.data.object || [];
          this.updateAvailableTiers();
        })
        .catch(this.error)
        .finally(this.done);
    },
    loadLinkedTiers() {
      if (!this.id || this.id == 0) return;

      this.$clubApi.get(`/tier/initial-rule/${this.plan.id}`)
        .then(response => {
          this.linkedTiers = (response.data.object || []).map(tr => ({
            tierId: tr.tierId,
            minLives: tr.minLives
          }));
          // Ordena por minLives
          this.linkedTiers.sort((a, b) => a.minLives - b.minLives);
          this.updateAvailableTiers();
        })
        .catch(this.error)
        .finally(this.done);
    },
    updateAvailableTiers() {
      // Todos os tiers estão disponíveis para adicionar
      // A validação será feita na hora de adicionar
      this.availableTiers = this.allTiers;
    },
    getTierName(tierId) {
      const tier = this.allTiers.find(t => t.id === tierId);
      return tier ? tier.name : 'Tier não encontrado';
    },
    getTierColor(tierId) {
      const tier = this.allTiers.find(t => t.id === tierId);
      return tier ? tier.color : '#000000';
    },
    validateTierRule(newTierId, newMinLives, ignoreTierId = null) {
      const newTierIndex = this.allTiers.findIndex(t => t.id === newTierId);
      if (newTierIndex === -1) {
        return {
          valid: false,
          message: 'Tier não encontrado.'
        };
      }

      for (const existingRule of this.linkedTiers) {
        // Ignora o tier que está sendo editado
        if (ignoreTierId && existingRule.tierId === ignoreTierId) {
          continue;
        }

        const existingTierIndex = this.allTiers.findIndex(t => t.id === existingRule.tierId);
        if (existingTierIndex === -1) continue;

        // Se o novo tier é maior (aparece depois na lista) e tem quantidade menor ou igual
        if (newTierIndex > existingTierIndex && newMinLives <= existingRule.minLives) {
          return {
            valid: false,
            message: `Não é possível adicionar um tier maior (${this.getTierName(newTierId)}) com quantidade de vidas (${newMinLives}) menor ou igual ao tier ${this.getTierName(existingRule.tierId)} que já possui ${existingRule.minLives} vidas.`
          };
        }

        // Se já existe um tier maior com quantidade menor ou igual à nova
        if (existingTierIndex > newTierIndex && existingRule.minLives <= newMinLives) {
          return {
            valid: false,
            message: `Já existe um tier maior (${this.getTierName(existingRule.tierId)}) com quantidade de vidas (${existingRule.minLives}) menor ou igual à quantidade informada (${newMinLives}).`
          };
        }
      }

      return { valid: true };
    },
    linkTierToPlan() {
      if (!this.selectedTier) {
        this.warning('Por favor, selecione um tier.');
        return;
      }

      if (!this.selectedMinLives || this.selectedMinLives < 0) {
        this.warning('Por favor, informe uma quantidade mínima de vidas maior que -1.');
        return;
      }

      const minLives = parseInt(this.selectedMinLives);

      // Verifica se o tier já existe para saber se é criação ou edição
      const existingTierIndex = this.linkedTiers.findIndex(tr => tr.tierId === this.selectedTier);
      const isEdit = existingTierIndex !== -1;

      // Se for edição e a quantidade de vidas for a mesma, não precisa fazer nada
      if (isEdit && this.linkedTiers[existingTierIndex].minLives === minLives) {
        this.warning('Esta combinação de tier e quantidade de vidas já está vinculada ao plano.');
        return;
      }

      // Valida as regras de negócio (ignora o tier atual se estiver editando)
      const validation = this.validateTierRule(this.selectedTier, minLives, isEdit ? this.selectedTier : null);
      if (!validation.valid) {
        this.warning(validation.message);
        return;
      }

      this.$clubApi.post('/tier/initial-rule', {
        planId: this.plan.id,
        tierId: this.selectedTier,
        minLives: minLives
      })
        .then(() => {
          if (isEdit) {
            this.success('Tier atualizado com sucesso!');
            // Atualiza localmente
            this.linkedTiers[existingTierIndex].minLives = minLives;
          } else {
            this.success('Tier vinculado ao plano com sucesso!');
            // Adiciona localmente
            this.linkedTiers.push({
              tierId: this.selectedTier,
              minLives: minLives
            });
          }
          // Ordena por minLives
          this.linkedTiers.sort((a, b) => a.minLives - b.minLives);
          this.updateAvailableTiers();
          this.selectedTier = null;
          this.selectedMinLives = null;
        })
        .catch(this.error)
        .finally(this.done);
    },
    unlinkTierFromPlan(tierId, minLives) {
      this.$clubApi.delete(`/tier/initial-rule/${this.plan.id}/min-lives/${minLives}`)
        .then(() => {
          this.success('Tier removido do plano com sucesso!');
          this.linkedTiers = this.linkedTiers.filter(tr => !(tr.tierId === tierId && tr.minLives === minLives));
          this.updateAvailableTiers();
        })
        .catch(this.error)
        .finally(this.done);
    },
    done() {
      NProgress.done();
    },
    error(error) {
      this.warning(error.response.data.msg);
    },
    success(message) {
      this.$notify({ type: 'success', message });
    },
    warning(message) {
      this.$notify({ type: 'warning', message });
    }
  },
};
</script>
<style scoped>
.input-group-append .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group .form-control:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

select:focus,
.el-select .el-input__inner:focus,
.el-select:focus .el-input__inner {
  outline: none !important;
  box-shadow: none !important;
  border-color: #ced4da !important;
}
</style>
